// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__DjEl4","productName":"Table_productName__TUWlg"};